import React from 'react';

export default function EmptyState({ title, subtitle }) {
  return (
    <div className="empty">
      <div className="emptyOrb" />
      <div className="emptyTitle">{title}</div>
      <div className="emptySub">{subtitle}</div>
    </div>
  );
}
